import styled from "styled-components";

export const Row = styled.div`
  margin: 0;
`;

export const DetallePrecertificacionContainer = styled.div`
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
`;

export const DetallePrecertificacionContent = styled.div`
  padding: 35px;
  background-color: #eee;
`;

export const InfoContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
`;

export const CodigosContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const RightAligned = styled.div`
  text-align: right;
`;

export const LeftAligned = styled.div`
  text-align: left;
`;

export const ComponentWrapperLeft = styled.div`
  text-align: left;
`;

export const ComponentWrapperRight = styled.div`
  text-align: right;
`;

export const CodigoContainer = styled.div`
  margin-bottom: 20px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;